import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
// import { StorageService } from '../../../../providers/storage.service';


@Component({
    selector: 'brick-trend-screen',
    templateUrl: 'brick-trend-screen.html',
})
export class BrickTrendScreen {
    param = "";
    tracks = {};
    /** 彩种类别 */
    type:any = 0;
    positionList = [
        { name: '五星', code: '5x' },
        { name: '前四', code: '4q' },
        { name: '后四', code: '4h' },
        { name: '前三', code: '3q' },
        { name: '中三', code: '3z' },
        { name: '后三', code: '3h' },
        { name: '前二', code: '2q' },
        { name: '后二', code: '2h' },
    ];
    longhuList = [
        { name: '万千 | 万百', code: '0102' },
        { name: '万十 | 万个', code: '0304' },
        { name: '千百 | 千十', code: '1213' },
        { name: '千个 | 百十', code: '1423' },
        { name: '百个 | 十个', code: '2434' }
    ];
    constructor(
        private viewCtrl: ViewController,
        private navpar: NavParams,
        // private storage: StorageService,
    ) {
        this.param = this.navpar.data.param != undefined ? this.navpar.data.param : "";
        this.type = this.navpar.data.LotteryType != undefined ? this.navpar.data.LotteryType : null;
        this.param = this.type == '01' ? this.param : 'dingwei';
    }

    //查询条件
    //TQQ 2016-12-30
    applyFilters(obj) {
        this.tracks["param"] = obj;
        this.dismiss(this.tracks);
    }


    //关闭
    //TQQ 2016-12-30
    dismiss(data?: any) {
        this.viewCtrl.dismiss(data);
    }



}


// WEBPACK FOOTER //
// ./src/pages/lotteryopen/brick-trend/brick-trend-screen/brick-trend-screen.ts